import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/common/download-qrcode.png'
import _imports_1 from '@/assets/images/common/qr.png'
import _imports_2 from '@/assets/images/common/dy.png'


const _withScopeId = n => (_pushScopeId("data-v-0c343f1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "suspendLayer" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "招聘", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"200px"}
}, null, -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下载", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"200px"}
}, null, -1))
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "公众号", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"200px"}
}, null, -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "抖音", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "客服电话：400-0311-616", -1))
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客服", -1))
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "顶部", -1))

import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'suspendLayer',
  setup(__props) {

const router = useRouter();

const toTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
};

const onClickRecruitment = () => {
  router.push("/recruitment");
};

return (_ctx: any,_cache: any) => {
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { onClick: onClickRecruitment }, [
      _createElementVNode("img", {
        src: require('@/assets/images/common/recruitment.png')
      }, null, 8, _hoisted_2),
      _hoisted_3
    ]),
    _createVNode(_component_a_popover, { placement: "left" }, {
      content: _withCtx(() => [
        _hoisted_4
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: require('@/assets/images/common/qrcode.png'),
            style: {"width":"26px","margin-bottom":"6px"}
          }, null, 8, _hoisted_5),
          _hoisted_6
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_popover, { placement: "left" }, {
      content: _withCtx(() => [
        _hoisted_7
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: require('@/assets/images/common/gzh.png')
          }, null, 8, _hoisted_8),
          _hoisted_9
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_popover, { placement: "left" }, {
      content: _withCtx(() => [
        _hoisted_10
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: require('@/assets/images/common/dy-icon.png')
          }, null, 8, _hoisted_11),
          _hoisted_12
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_popover, { placement: "left" }, {
      content: _withCtx(() => [
        _hoisted_13
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: require('@/assets/images/common/kf.png')
          }, null, 8, _hoisted_14),
          _hoisted_15
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", { onClick: toTop }, [
      _createElementVNode("img", {
        src: require('@/assets/images/common/top.png')
      }, null, 8, _hoisted_16),
      _hoisted_17
    ])
  ]))
}
}

})